'use client';

import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';
import { DebugLink } from '@/app/components/search/components/Banners/Debug/styled.ts';
import { BASE_PATH } from '@/app/components/search/utils/path.ts';

export const DebugAuth = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const callbackUrl = `${BASE_PATH}${pathname}${search ? `?${search}` : ''}`;

  return (
    <span>
      🔎{' '}
      <DebugLink
        href="#"
        style={{ display: 'inline' }}
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          signIn('vauth', { callbackUrl });
        }}
      >
        Sign In for Debug Info
      </DebugLink>
    </span>
  );
};
